import { httpApi } from '@api/http.api.ts';
import type {
    ANSWER_STATUS,
    COMMON_QUIZ_STATUS,
    QUIZ_NOTIFICATION,
} from '@routes/sidebar/learning/___pages___/learning-overview/ui/overview/quiz/___shared___/constants.ts';

type CommonQuizStatus = (typeof COMMON_QUIZ_STATUS)[keyof typeof COMMON_QUIZ_STATUS];

export type PracticeQuizStatus = CommonQuizStatus;
export type AnswerStatus = (typeof ANSWER_STATUS)[keyof typeof ANSWER_STATUS];
export type QuizNotification = (typeof QUIZ_NOTIFICATION)[keyof typeof QUIZ_NOTIFICATION];

export interface LearningPracticeQuizResponse {
    requiredPercentScore: number;
    questions: QuizQuestion[];
    quizStatus: CommonQuizStatus;
    numberOfQuestions: number;
    currentPercentScore: number | null;
    highestPercentScore: number | null;
}

export interface QuizAnswer {
    id: number;
    text: string;
    questionId: number;
}

export interface QuizAnswerRequest {
    answers: number[];
}

export interface QuizAnswerResponse {
    correct: number[];
    quizQuestionAnswerStatus: AnswerStatus;
}

interface QuizFinishResponse {
    requiredPercentScore: number;
    highestPercentScore: number;
    currentPercentScore: number;
    quizStatus: CommonQuizStatus;
}

export interface QuizPracticeFinishResponse extends QuizFinishResponse {
    lastQuizFinished: boolean;
}

export interface QuizQuestion {
    id: number;
    questionText: string;
    answers: QuizAnswer[];
    userAnswers: number[];
    correctAnswers: number[];
    selectAllRight: boolean;
    quizQuestionAnswerStatus: AnswerStatus;
    introText: string | null;
    outroText: string | null;
}

export const getApiPracticeQuizData = (pathwayId: string, quizId: number): Promise<LearningPracticeQuizResponse> =>
    httpApi.get<LearningPracticeQuizResponse>(`learning/${pathwayId}/quiz/${quizId}`).then(({ data }) => data);

export const postApiPracticeQuizStart = (pathwayId: string, quizId: number): Promise<LearningPracticeQuizResponse> =>
    httpApi
        .post<LearningPracticeQuizResponse>(`learning/${pathwayId}/quiz-start/${quizId}`, {})
        .then(({ data }) => data);

export const postApiPracticeQuizAnswer = (
    payload: QuizAnswerRequest,
    quizId: number,
    questionId: number,
    pathwayId: string,
): Promise<QuizAnswerResponse> =>
    httpApi
        .post<QuizAnswerResponse>(`learning/${pathwayId}/quiz/${quizId}/quiz-answer/${questionId}`, {
            ...payload,
        })
        .then(({ data }) => data);

export const postApiPracticeQuizFinish = (pathwayId: string, quizId: number): Promise<QuizPracticeFinishResponse> =>
    httpApi
        .post<QuizPracticeFinishResponse>(`learning/${pathwayId}/${quizId}/quiz-finish`, {})
        .then(({ data }) => data);

export const postResetPracticeQuizData = (pathwayId: string, quizId: number): Promise<any> =>
    httpApi.post<any>(`learning/${pathwayId}/quiz/${quizId}/reset`).then(({ data }) => data);
